// Outline variant of assets/icons/document-info.svg

const DocumentInfoOutlineIcon = ({
  size = 24,
  color = "#9333EA",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="3" y="2" width="18" height="20" rx="2" stroke={color} strokeWidth={strokeWidth} />
      <path d="M8 8H16" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M8 12H16" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M8 16H13" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
};

export default DocumentInfoOutlineIcon;
